<template>
  <div>
    <b-card title="Operations Reports">
      <b-row>
        <b-col
          cols="12"
          lg="6"
          class="my-1 align-items-start"
        >
          <v-select
            v-model="selectedReport"
            label="name"
            placeholder="Select Required Report"
            :options="filteredOptions"
          />
        </b-col>
      </b-row>
    </b-card>
    <div v-if="selectedReport.key === 'key_16'">
      <OperationsReschedule />
    </div>
    <div v-if="selectedReport.key === 'key_11' || selectedReport.key === 'key_12' || selectedReport.key === 'key_15'">
      <Operations
        :report-key="selectedReport.key"
        :report-name="selectedReport.name"
      />
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import OperationsReschedule from './Operations/OperationsReschedule.vue'
import Operations from './Operations/Operations.vue'

export default {
  components: {
    OperationsReschedule,
    Operations,
    BCard,
    BRow,
    BCol,
    vSelect,
  },
  data() {
    return {
      selectedReport: '',
      reportOptions: [
        {
          name: 'ACTIVE RESCHEDULE', component: 'OperationsReschedule', key: 'key_16', permission: 'operations-reschedule-report',
        },
        {
          name: 'CURRENTLY RECEIVED AT DESTINATION WAREHOUSE', component: 'Operations', key: 'key_11', permission: 'view-received-at-destination-warehouse',
        },
        {
          name: 'CURRENTLY ASSIGNED TO DESTINATION RIDER', component: 'Operations', key: 'key_12', permission: 'view-assigned-to-destination-rider',
        },
        {
          name: 'CURRENTLY RETURNED TO DESTINATION WAREHOUSE', component: 'Operations', key: 'key_15', permission: 'view-returned-to-destination-warehouse',
        },
      ],
    }
  },
  computed: {
    filteredOptions() {
      return this.reportOptions.filter(option => this.hasPermission(option.permission))
    },
  },
  methods: {
    hasPermission(permission) {
      return this.$store.getters.permissions.includes(permission)
    },
  },
}
</script>
<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';

</style>
